import { ReactNode } from 'react';
import { forwardRef } from 'react';

interface SectionProps {
  id?: string;
  title?: string;
  description?: string;
  children?: ReactNode;
  background?: 'grey' | 'white';
}

const Section = forwardRef<HTMLElement, SectionProps>(
  ({ children, id, title, description, background = 'grey' }, ref) => {
    return (
      <section ref={ref} className={background === 'grey' ? 'bg-[#fafafa]' : 'bg-white'} id={id}>
        <div className='relative px-4 md:container mx-auto py-8 pb-10 md:py-[50px] md:pb-[56px]'>
          {title && <h2 className='font-extrabold m-0 mb-[5px]'>{title}</h2>}
          {description && (
            <p className='text-[#525252] tracking-tight text-[1.125rem]/[1.35rem] font-regular'>{description}</p>
          )}
          {children}
        </div>
      </section>
    );
  }
);

Section.displayName = 'Section';

export default Section;
